import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {BaseUrlInterceptor} from "@mods/shared/interceptors/base-url.interceptor";

export * from './base-url.interceptor';

export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: BaseUrlInterceptor, multi: true },
]
